import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Instagram",
  "use": "Instagram-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Instagram\"><path fill-rule=\"evenodd\" d=\"M21 12h22c8.284 0 15 6.716 15 15v22c0 8.284-6.716 15-15 15H21c-8.284 0-15-6.716-15-15V27c0-8.284 6.716-15 15-15zm11 41c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm17-30a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM32 47a9 9 0 1 1 0-18 9 9 0 0 1 0 18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol